import { add, eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns'

export const MONDAY = 0
export const INITIAL_VALUE = []
export const INITIAL_SINGLE_VALUE = [' ']
export const DAY_FULL_NAME_FORMAT = 'eeee'
export const DAY_SHORT_NAME_FORMAT = 'eee'
export const TIME_PICKER_PLACEHOLDER = '00:00'

export const FIELD_NAMES = {
  SINGLE_HOUR: 'singleHour',
  HAS_CUSTOM_HOURS: 'hasCustomHours',
  CUSTOM_HOURS: 'customHours',
}

export const weekdays = eachDayOfInterval({
  start: add(startOfWeek(new Date()), { days: 1 }),
  end: add(endOfWeek(new Date()), { days: 1 }),
})
export const getDay = (day) => format(weekdays[day], DAY_FULL_NAME_FORMAT).toLowerCase()
export const allWeekDays = weekdays.map((_, index) => getDay(index))
export const weekdaysGraphqlString = allWeekDays
  .map((day) => [
    `${day} {
    startTime
    endTime
  }`,
  ])
  .join('\n')
